export const TRACKING_STEPS = [
  "Ready for assessment",
  "Currently in assessment",
  "Assessment outcome",
];

export const TRACKING_STEPS_MOBILE = ["Ready for assessment", "Currently in assessment", "Assessment outcome"];

export const DECLINED_REASONS = {
    AFFORDABILITY: "Affordability",
    BANK_ACCOUNT_CONDUCT: "BankAccountConduct",
    CREDIT_HISTORY: "CreditHistory",
    EMPLOYMENT_STATUS: "Employment",
    COMBINATION_OF_REASONS: "CombinationOfReasons",
    OUTSIDE_OF_LENDING_CRITERIA: "OutsideOfLendingCriteria",
    RECENT_OR_PREVIOUS_CONDUCT: "PreviousLoanConduct",
}


